import { P, match } from "ts-pattern";
import {
  ControlDataTypeKey,
  Types,
  Schema
} from "../prop-controllers";
import { z } from "zod";
const paddingSideDataSchema = z.object({
  value: z.number(),
  unit: z.literal("px")
});
const paddingDataSchema = z.object({
  paddingTop: paddingSideDataSchema.nullable().optional(),
  paddingRight: paddingSideDataSchema.nullable().optional(),
  paddingBottom: paddingSideDataSchema.nullable().optional(),
  paddingLeft: paddingSideDataSchema.nullable().optional()
}).transform((v) => ({
  paddingTop: v.paddingTop,
  paddingRight: v.paddingRight,
  paddingBottom: v.paddingBottom,
  paddingLeft: v.paddingLeft
}));
const responsivePaddingDataSchema = Schema.responsiveValue(paddingDataSchema);
const paddingPropControllerDataV0Schema = responsivePaddingDataSchema;
const PaddingPropControllerDataV1Type = "prop-controllers::padding::v1";
const paddingPropControllerDataV1Schema = z.object({
  [ControlDataTypeKey]: z.literal(PaddingPropControllerDataV1Type),
  value: responsivePaddingDataSchema
});
const paddingPropControllerDataSchema = z.union([
  paddingPropControllerDataV0Schema,
  paddingPropControllerDataV1Schema
]);
const PaddingPropControllerFormat = {
  ClassName: "makeswift::prop-controllers::padding::format::class-name",
  ResponsiveValue: "makeswift::prop-controllers::padding::format::responsive-value"
};
function Padding(options = {}) {
  return { type: Types.Padding, version: 1, options };
}
Padding.Format = PaddingPropControllerFormat;
function getPaddingPropControllerDataResponsivePaddingData(data) {
  return match(data).with(
    { [ControlDataTypeKey]: PaddingPropControllerDataV1Type },
    (v1) => v1.value
  ).otherwise((v0) => v0);
}
function createPaddingPropControllerDataFromResponsivePaddingData(responsivePaddingData, definition) {
  return match(definition).with(
    { version: 1 },
    P.nullish,
    () => ({
      [ControlDataTypeKey]: PaddingPropControllerDataV1Type,
      value: responsivePaddingData
    })
  ).otherwise(() => responsivePaddingData);
}
export {
  Padding,
  PaddingPropControllerDataV1Type,
  PaddingPropControllerFormat,
  createPaddingPropControllerDataFromResponsivePaddingData,
  getPaddingPropControllerDataResponsivePaddingData,
  paddingPropControllerDataSchema
};
//# sourceMappingURL=padding.js.map